<template>
  <v-container>
    <v-tab-item class="pb-0" eager>
      <validation-observer v-slot="{ valid }" id="importacao-sped-infos-basicas">
        <validation-helper :interceptor="valid" @isValid="$emit('step-observer', {step: 0, complete: $event})" />
        <div class="text-center display-1 font-weight-normal mb-6">
          Preencha as informações básicas da importação
        </div>
        <v-row class="mx-auto">
          <v-col class="pb-0" cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                label="Nome"
                outlined
                v-model="nome"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col class="pb-0" cols="6">
            <general-encoding :encoding.sync="encoding" />
          </v-col>
          <v-col class="pb-0" cols="6">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                no-gutters
                outlined
                label="Tipo"
                :items="itemsTipo"
                item-text="text"
                item-value="value"
                v-model="tipo"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <div class="text-center display-1 font-weight-normal mb-6">
        Faça upload de todos os arquivos envolvidos na importação
      </div>
      <v-alert dense outlined type="info" color="blue" class="pa-0">
        Faça upload de arquivos com extensão .txt, ou arquivos ZIP que contenham arquivos .txt
      </v-alert>
      <span id="input-upload-importacoes-sped">
        <upload-files
          @file:uploaded="handleFileUploaded"
          :extensoesPermitidas="['.txt, .zip']"
          :parametroExtra="importacaoId"
          :customFunctionUpload="require('../../services/importacoesSpedService.js').default.uploadFile"
        />
      </span>
    </v-tab-item>
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('step-observer', {step: 1, complete: $event})" />
        <mapeamento-files
          v-if="uploadedFiles.length > 0 && tab != 0"
          ref="refMapeamentos"
          :uploadedFiles="uploadedFiles"
          :idImportacao="importacaoId"
          :importacao="exportData()"
          @mapeamento:apagar-arquivo="handleMapeamentoArquivoApagado"
        />
        <validation-provider v-slot="{ errors }" rules="min_value:1">
          <input type="hidden" :value="uploadedFiles.length" :error-messages="errors" />
        </validation-provider>
      </validation-observer>
  </v-container>
</template>
<script>
  import importacoesSpedService from '../../services/importacoesSpedService.js';

  export default {
    components: {
      GeneralEncoding: () => import("@/components/general/GeneralEncoding.vue"),
      ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
      UploadFiles: () => import('@/components/general/UploadFiles'),
      MapeamentoFiles: () => import('@/components/importacoesSped/MapeamentoFiles'),
    },

    data: () => ({
      nome: '',
      encoding: 'UTF-8',
      tipo: 'ICMS',
      uploadedFiles: [],
      itemsTipo:[
        {text:'ICMS',value:'ICMS'},
        {text:'Contribuição',value:'CONTRIBUICAO'}
      ]
    }),

    props:{
      importacaoId:{
        type: Number
      },

      tab:{
        type: Number
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.getImportacaoSpead(this.$route.params.id);
        this.getFilesImportacao(this.$route.params.id);
      }
    },

    methods: {
      exportData(){
        return {
          titulo: this.nome,
          encoding: this.encoding,
          tipo: this.tipo
        }
      },

      getFilesImportacao(id){
        importacoesSpedService.getFilesImportacao(id)
        .then(resp => {
          resp.data.data.forEach(file => {
            this.uploadedFiles.push(file)
          });
        })
        .catch(err => {
          this.$toast.error("Erro ao buscar arquivos de Importações de SPED.", "", { position: "topRight"});
          console.error(err);
        });
      },

      setUpdates(){
        return this.$refs.refMapeamentos.setUpdates();
      },

      handleFileUploaded(event) {
        const files = event.files;
        files.forEach(file => this.uploadedFiles.push(file));
      },

      handleMapeamentoArquivoApagado(event) {
        this.uploadedFiles = this.uploadedFiles.filter(item => item.id !== event.id);
        
        importacoesSpedService.apagarArquivo(event)
        .then(resp => {  
        })
        .catch(err => {
          this.$toast.error("Erro ao excluir arquivo de Importações de SPED.", "", { position: "topRight"});
          console.error(err);
        });
      },

      getImportacaoSpead(id){
        importacoesSpedService.getImportacaoSpead(id)
        .then(resp => {  
          this.nome = resp.data.data[0].titulo;
          this.encoding = resp.data.data[0].encoding;
          this.tipo = resp.data.data[0].tipo;
        })
        .catch(err => {
          this.$toast.error("Erro ao buscar dados de Importações de SPED.", "", { position: "topRight"});
          console.error(err);
        });
      },
    }
  }
</script>